import 'css-chunksrc/feature/pay-in-out/PayInOutVoidConfirmation.module.scss';export default {
  "warning": "PayInOutVoidConfirmation_warning"
};